import EntityOverviewPage from 'Components/Organisms/Entity/EntityOverviewPage/EntityOverviewPage';
import PageTemplate from 'Components/Templates/Page/Page/PageTemplate';
import { Helmet } from 'react-helmet-async';
import { ROUTES } from 'Services/Route/Route.types';

const ContactOverviewPage = () => {
    return (
        <PageTemplate>
            <Helmet>
                <title>{ ROUTES.CONTACTS.title }</title>
            </Helmet>

            <EntityOverviewPage
                entity_name='contact'
            />
        </PageTemplate>
    )
}

export default ContactOverviewPage;